import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Inject,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { OnDestroy$ } from '@pdtec/ngx-observable-lifecycle';
import { ChangedFilterEvent, HTTPSearchResultFilter, HTTPSearchResultFilterValue } from 'src/app/models';
import { ToursStateService } from 'src/app/services/tours-state.service';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { FilterStarsComponent } from './stars/filter-stars.component';
import { FilterNightsComponent } from './nights/filter-nights.component';
import { FilterHorizontalComponent } from './horizontal/filter-horizontal.component';
import { FilterDefaultComponent } from "./default/filter-default.component";
import { HotelNameSearchComponent } from '../../hotel-name-search/hotel-name-search.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from '../../../config/hotel-tours-list-page.config';

@Component({
  selector: 'app-filter',
  templateUrl: environment.mobile ? './filter.component.mobile.html' : './filter.component.html',
  styleUrls: environment.mobile ? ['./filter.component.mobile.scss'] : [
    './filter.component.scss',
    '../../../../../../../build/assets/desktop/_include/scss/filter-show-more.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FilterDefaultComponent,
    FilterHorizontalComponent,
    FilterNightsComponent,
    FilterStarsComponent,
    HotelNameSearchComponent,
  ],
})
export class FilterComponent extends OnDestroy$ implements OnInit, OnDestroy {
  @Input() filter: HTTPSearchResultFilter;
  @Input() isOpen = false;
  @Input() onlySmartFilter = false;
  @Output() changeSelectedCount = new EventEmitter<ChangedFilterEvent>();

  filterId: string;
  readonly visibleValuesLimit = 5;
  showAllValues = false;
  messages: any;
  private destroy$ = new Subject<void>();

  constructor(
    private state: ToursStateService,
    private cdRef: ChangeDetectorRef,
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
  ) {
    super();
    this.messages = this.hotelToursPageConfig.translates.filters;

    this.filterId = 'id' + new Date().getTime() + Math.floor(Math.random() * 1001);
  }

  toggleValue(key: string, value: HTTPSearchResultFilterValue, event: any) {
    this.state.toggleFilterValue(key, value.filterValue);

    const selectedFiltersCount = this.state.getState().selectedFiltersCount;
    const applyedFiltersCount = this.state.getState().applyedFiltersCount;

    if (this.onlySmartFilter) {
      this.onlySmartFilter = false;
    }

    this.changeSelectedCount.emit({
      event,
      selectedCount: selectedFiltersCount,
      applyedCount: applyedFiltersCount,
      onlySmartFilter: this.onlySmartFilter,
    });
  }

  resetFilter(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.state.resetFilter(this.filter.filterKey);

    const selectedFiltersCount = this.state.getState().selectedFiltersCount;
    const applyedFiltersCount = this.state.getState().applyedFiltersCount;

    if (this.onlySmartFilter) {
      this.onlySmartFilter = false;
    }

    this.changeSelectedCount.emit({
      event,
      selectedCount: selectedFiltersCount,
      applyedCount: applyedFiltersCount,
      onlySmartFilter: this.onlySmartFilter,
    });
  }

  hasSelectedFilter(): boolean {
    return this.state.hasSelectedFilter(this.filter.filterKey);
  }

  get visibleValues(): HTTPSearchResultFilterValue[] {
    const values = this.filter.values;
    if (values.length <= this.visibleValuesLimit) {
      return values;
    }

    const sortedValues = [...values].sort((a, b) =>
      Number(this.state.filterSelected(this.filter.filterKey, b.filterValue, true))
      - Number(this.state.filterSelected(this.filter.filterKey, a.filterValue, true))
    );

    return this.showAllValues ? sortedValues : sortedValues.slice(0, this.visibleValuesLimit);
  }

  ngOnInit() {
    this.state.filtersApplyed$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showAllValues = false;
        this.cdRef.markForCheck();
      });

    this.state.updated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Значение фильтра активно
   */
  isActive(key: string, value: HTTPSearchResultFilterValue) {
    let filterValue = value.filterValue;

    if (this.onlySmartFilter) {
      const selectedValue = this.state.getState().selectedFilters[key];

      if (selectedValue === filterValue) {
        filterValue = selectedValue;
      }
    }
    return this.state.filterSelected(key, filterValue);
  }

  /**
   * Скрыть / показать шапку
   */
  toggleHeader() {
    this.isOpen = !this.isOpen;

    if (environment.mobile) {
      open_popup({
        target: `#${this.filterId}`,
        footer: true,
        header: true,
      });
    }
  }

  trackByFn(_, item: HTTPSearchResultFilterValue) {
    return item.filterValue;
  }

  isHorizontalItems(filter: string) {
    switch(filter) {
      case 'seaLines': {
        return true;
      }
      case 'ratings': {
        return true;
      }
      case 'beachTypes': {
        return true;
      }
      default: {
        return false;
      }
    }
  }

  ratingStringValue(value: number) {
    switch(value) {
      case 9: {
        return 'отлично';
      }
      case 8: {
        return 'хорошо';
      }
      case 7: {
        return 'средне';
      }
    }
  }
}
